import { initializeApp } from 'firebase/app';
import * as firebaseAnalytics from 'firebase/analytics';

let analytics: firebaseAnalytics.Analytics;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
let userLatitude = 0;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
let userLongitude = 0;

interface FirebaseConfigProps {
  apiKey: string;
  authDomain: string;
  databaseURL: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
}

const getLocation = () => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position: any) => {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        userLatitude = latitude;
        userLongitude = longitude;
      },
      () => {},
    );
  }
};

export const init = (firebaseConfig: FirebaseConfigProps) => {
  getLocation();
  const app = initializeApp(firebaseConfig);
  analytics = firebaseAnalytics.getAnalytics(app);
};

export default class FirebaseAnalytics {
  static get MODULES() {
    return {
      CREDIT: 'Credit',
      FACTORING: 'Factoring',
      FUEL: 'Fuel',
      LOADS: 'TMS',
      MY_FLEET: 'My Fleet',
      RTSPRO: 'RTSPro',
      SHOPS: 'Shops',
      TRIP_MANAGEMENT: 'Trip Management',
      LOAD_MANAGEMENT: 'Load Management',
      COMPANY_INFO: 'Company Info',
      ENTERPRISE: 'Enterprise',
    };
  }

  static get PARAMETERS() {
    return {
      ACTION: 'action',
      BRANDS: 'brands',
      CITY: 'city',
      CLIENT_ID: 'client_id',
      CONFIRMATION_EMAIL: 'confirmation_email',
      CONTACT: 'contact',
      COUNT: 'count',
      DATE: 'date',
      DESTINATION: 'destination',
      DISCOUNT: 'discount',
      DRIVER: 'driver',
      ENDING_LOCATION: 'ending_location',
      FEATURED_STATIONS: 'featured_stations',
      FUEL_TRANSACTION_ID: 'fuel_transaction_id',
      GALLONS: 'gallons',
      HAS_FUNDING_INSTRUCTIONS: 'has_funding_instructions',
      HAS_NOTE: 'has_note',
      HIGHWAYS: 'highways',
      ID: 'Id',
      INVOICE_ID: 'invoice_id',
      INVOICE_NUMBER: 'invoice_number',
      ITEM_LIST_COUNT: 'item_list_count',
      LABEL: 'label',
      LAT: 'lat',
      LNG: 'lng',
      LOAD_ID: 'load_id',
      LOAD_ID_LIST: 'load_id_list',
      LOAD_NUMBER: 'load_number',
      MILEAGE: 'mileage',
      MODULE: 'module',
      NAME: 'name',
      PAGE: 'page',
      PAYMENT_RECEIVED_DATE: 'payment_received_date',
      PHONE: 'phone',
      PRICE: 'price',
      PO_NUMBER: 'po_number',
      PREVIOUS_STATUS: 'previous_status',
      PURCHASE_ID: 'purchase_id',
      SEARCH_NAME: 'search_name',
      SEARCH_TYPE: 'search_type',
      SEARCH_VALUE: 'searchValue',
      STATE: 'state',
      STATES: 'states',
      STARTING_LOCATION: 'starting_location',
      STATUS: 'status',
      STOP_ID: 'stop_id',
      STOPS: 'stops',
      TAB_SELECTED: 'tab_selected',
      TRAILER_NUMBER: 'trailer_number',
      TRANSACTION_DATE: 'transaction_date',
      TRANSACTION_TIME: 'transaction_time',
      TRIP_NO: 'trip_no',
      TRUCK: 'truck',
      TOTAL_LOADS: 'total_loads',
      TOTAL_AMOUNT: 'total_amount',
      TYPE: 'type',
      TYPES: 'types',
      USER_ID: 'UserID',
      USER_TYPE: 'userType',
      VALUE: 'value',
    };
  }

  static get EVENTS() {
    return {
      CHOOSE_LIBRARY: 'choose_library',
      CHOOSE_PDF: 'choose_pdf',
      CLICK: 'click',
      CLICK_MENU: 'click_menu',
      CREATE: 'create',
      DELETE: 'Delete',
      DETAILS_VIEW: 'Details_view',
      EDIT: 'edit',
      ENTER: 'enter',
      EULA_ACCEPTED: 'eula_accepted',
      EXIT: 'exit',
      EXPORT: 'export',
      FILTER: 'filter',
      FOCUSED: 'focused',
      PAGE_VIEW: 'page_view',
      RECEIVED: 'received',
      SAVE: 'save',
      SEARCH: 'search',
      SELECT: 'select',
      SET_FAVORITE: 'set_favorite',
      SORT: 'sort',
      SUBMIT: 'submit',
      TAB_SELECTED: 'tab_selected',
      TAKE_PHOTO: 'take_photo',
      UPLOAD: 'upload',
      EDIT_DETAILS: 'edit_details',
    };
  }

  static get LABELS() {
    return {
      ADD_DRIVER: 'Add Driver',
      ADD_STOP: 'Add Stop',
      ADD_TRUCK: 'Add Truck',
      ADD_NOTES: 'Add Notes',
      ADD_NOTES_TRUCK: 'Add Notes Truck',
      ADD_NOTES_TRAILER: 'Add Notes Trailer',
      AGING: 'Aging',
      AMOUNT: 'Amount',
      AVOID_TOLLS: 'Avoid Tolls',
      COMPANY_INFO: 'Company Info',
      CONTACT_NAME: 'Contact Name',
      CONTACT_PHONE_NUMBER: 'Contact Phone Number',
      CREATE_LOAD: 'Create Load',
      DEBTOR: 'Debtor',
      DRIVER: 'Driver',
      DOCUMENT: 'Document',
      DOCUMENT_DRIVER: 'Document Driver',
      DOCUMENT_TRUCK: 'Document Truck',
      EDIT_LOAD: 'Edit Load',
      EMPTY_MILES: 'Empty Miles',
      EXPORT: 'Export',
      EXPORT_INVOICES: 'Export Invoices',
      FUEL: 'Fuel',
      HAZMAT: 'Hazmat',
      IFTA: 'IFTA',
      LOAD: 'Load',
      LOADS: 'Loads',
      LOAD_NUMBER: 'Load Number',
      LOADED_MILES: 'Loaded Miles',
      LOGOUT: 'Logout',
      MY_FLEET: 'My Fleet',
      EQUIPMENT: 'Equipment',
      OPEN_BORDERS: 'Open Borders',
      PAYMENT_DATE: 'Payment Date',
      PO_NUMBER: 'PO Number',
      PRINT: 'Print',
      PURCHASE_IFTA: 'Purchase IFTA',
      CREATE_IFTA: 'Create IFTA',
      CANCEL_PAYMENT: 'Cancel Payment',
      REMOVE_STOP: 'Remove Stop',
      SETTINGS: 'Settings',
      SUBMIT_TO_RTS: 'Submit to RTS',
      TRUCK: 'Truck',
      IFTA_FUEL_EDIT: 'IFTA Fuel Edit',
      IFTA_STOPS_EDIT: 'IFTA Stops Edit',
      ACQUIRE_PROTRANS: 'Acquire Protransport',
      SEARCH_NEW_DRIVER: 'Search New Driver',
      SEARCH_NEW_TRUCK: 'Search New Truck',
      UPLOAD_LOGO: 'Upload Logo',
      INVOICE_SUMMARY_VIEW_DETAILS: 'Submission View Details',
      ADD_NEW: 'Add New',
      MORE_DETAILS: 'More Details',
      STATEMENTS: 'Statements',
      REQUEST_UPGRADE: 'Request Upgrade',
      UPGRADE_PLAN: 'Upgrade Plan',
      START_INTEGRATION: 'Start Integration',
      STOP_INTEGRATION: 'Stop Integration',
      CREATE_STATEMENT: 'Create Statement',
      VIEW: 'View',
      EDIT: 'Edit',
      DETAILS: 'Details',
      DELETE: 'Delete',
      PARTNER_DROPDOWN: 'Partner Dropdown',
      STATEMENT_DATE: 'Statement Date',
      RATE_TYPE: 'Rate Type',
      FUEL_ENTRIES: 'Fuel Entries',
      CANCEL: 'Cancel',
      SAVE: 'Save',
      STATEMENT_RANGE: 'Statement Range',
      RATE: 'Rate',
      CREDITS: 'Credits',
      DEDUCTIONS: 'Deductions',
      COMMENTS: 'Comments',
      EMAIL: 'Email',
      SEARCH_VIN: 'Search VIN',
      TRAILER: 'Trailer',
      SKIP: 'Skip',
    };
  }

  static get PAGES() {
    return {
      COMPANY: 'Company Info',
      FUEL: 'Fuel',
      IFTA: 'IFTA',
      LOAD_EDIT: 'Load_Edit',
      LOAD_LIST: 'Load_List',
      MY_FLEET: 'My_Fleet',
      EQUIPMENT: 'Equipment',
      INVOICE_SUMMARY: 'Invoice_Summary',
      INVOICE_EMAIL_MODAL: 'Invoice_Email_Modal',
      INVOICE_EMAIL_CANCEL_MODAL: 'Invoice_Email_Cancel_Modal',
      MENU: 'Menu',
      SETTINGS: 'Settings',
      SUB_HEADER: 'Sub_Header',
      AGING: 'Aging',
      DRIVER_EDIT_MODAL: 'Driver Edit Modal',
      TRUCK_EDIT_MODAL: 'Truck_Edit_Modal',
      SUBMISSION_FAILED_SNACKBAR: 'Submission_Failed_Snackbar',
      STATEMENTS: 'Statements',
      STATEMENT_EDIT: 'Statement Edit',
      STATEMENT_VIEWER: 'Statements Viewer',
      MARKETING_PLANS: 'Marketing Plans',
      ADD_EQUIPMENT: 'Add Equipment',
    };
  }

  static setCurrentScreen(name: string) {
    firebaseAnalytics.logEvent(analytics, name);
  }

  static setUser(userId: string, userType?: string) {
    firebaseAnalytics.setUserProperties(analytics, { [FirebaseAnalytics.PARAMETERS.USER_ID]: userId });
    firebaseAnalytics.setUserId(analytics, userId);
    if (userType) {
      firebaseAnalytics.setUserProperties(analytics, { [FirebaseAnalytics.PARAMETERS.USER_TYPE]: userId });
    }
  }

  static logPageView(page: string) {
    firebaseAnalytics.logEvent(analytics, FirebaseAnalytics.EVENTS.PAGE_VIEW, { module: FirebaseAnalytics.MODULES.ENTERPRISE, page });
  }

  static sendEvent(event: string, module: string, page: string, customObject?: Object) {
    const payload: any = customObject || {};
    payload['module'] = module;
    payload['page'] = page;

    firebaseAnalytics?.logEvent(analytics, event, payload);
  }
}
